module.exports = __webpack_public_path__ + "static/media/ui-ux.55d2670a.png";